import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { type, colors, space } from '../theme';
import Chip from '../components/Chip';
import SectionTitle from '../components/SectionTitle';

// Matches the in-app Summary block: heading, body text, and meta chips
// (meeting type / deal stage / sentiment) below. Deal stage and sentiment
// are internal reads — stripped for the shared (prospect-facing) variant.
const SummarySection = ({ report }) => {
  const summary = report.summary;
  if (!summary) return null;
  const meeting = report.meeting || {};
  const isShared = report.variant === 'shared';

  return (
    <View wrap={false}>
      <SectionTitle>Summary</SectionTitle>
      <Text style={[type.body, { color: colors.inkSoft }]}>{summary}</Text>
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginTop: space.sm }}>
        {meeting.type && <Chip variant="neutral">{meeting.type}</Chip>}
        {!isShared && meeting.dealStage && <Chip variant="warning">{meeting.dealStage}</Chip>}
        {!isShared && meeting.sentiment && (
          <Chip variant={meeting.sentiment === 'Positive' ? 'success' : meeting.sentiment === 'Negative' ? 'danger' : 'warning'}>
            {meeting.sentiment}
          </Chip>
        )}
      </View>
    </View>
  );
};

export default SummarySection;
